module.exports = __webpack_public_path__ + "static/media/Alone.9714ab53.txt";